import { render, staticRenderFns } from "./Creditor.vue?vue&type=template&id=94e0a9a8&scoped=true&"
import script from "./Creditor.vue?vue&type=script&lang=js&"
export * from "./Creditor.vue?vue&type=script&lang=js&"
import style0 from "./Creditor.vue?vue&type=style&index=0&id=94e0a9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e0a9a8",
  null
  
)

export default component.exports